import { CheckCircleFilled, CloseCircleOutlined } from '@ant-design/icons';

interface PasswordChecklistProps {
	password: string;
}

const rules = [
	{ label: 'Minimum 8 characters', test: (p: string) => p.length >= 8 },
	{ label: 'Uppercase letter', test: (p: string) => /[A-Z]/.test(p) },
	{ label: 'Lowercase letter', test: (p: string) => /[a-z]/.test(p) },
	{ label: 'Number', test: (p: string) => /[0-9]/.test(p) },
	{ label: 'Special character', test: (p: string) => /[^A-Za-z0-9]/.test(p) },
];

export function PasswordChecklist({ password }: PasswordChecklistProps) {
	return (
		<div className="flex flex-col gap-1 mt-2 mb-1">
			{rules.map((rule) => {
				const passed = password ? rule.test(password) : false;
				return (
					<div key={rule.label} className="flex items-center gap-2 text-sm">
						{passed ? (
							<CheckCircleFilled className="text-green-500" />
						) : (
							<CloseCircleOutlined className="text-gray-400" />
						)}
						<span className={passed ? 'text-green-600' : 'text-gray-500'}>
							{rule.label}
						</span>
					</div>
				);
			})}
		</div>
	);
}
